module.exports = ".application-label {\n  font-weight: 500;\n  width: 350px;\n  padding-top: 5px; }\n\n.card {\n  margin-top: 5px; }\n\n.app-table td {\n  border: 1px solid rgba(0, 0, 0, 0.03); }\n\n.form-control:disabled {\n  opacity: 1 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/apply-gov-services/apply-gov-services.component.scss
// module id = ./src/app/modules/common-main/components/apply-gov-services/apply-gov-services.component.scss
// module chunks = main